<!--
  File name: NotificationsList.vue
  Program Description:
    - This component displays the In-App notifications list.
    - When accessed, it renders the new notifications available only to the user.
-->
<template>
  <v-card>
    <v-card-title>
      <v-row>
        <v-col
          cols="12"
          align="center"
        >
          <span class="title"> Notifications </span>
        </v-col>
      </v-row>
    </v-card-title>
    <v-divider />
    <v-container>
      <v-row style="padding: 0 15px;">
        <v-col cols="8" />
        <v-col
          cols="4"
          align="right"
        >
          <span
            v-if="notifications.length"
            style="cursor: pointer"
            @click="checkNotifications"
          >
            See all
          </span>
        </v-col>
      </v-row>
    </v-container>

    <v-card-text
      style=" max-width: 600px; padding: 0 10px; height: 100%; min-height: 100px"
    >
      <v-container
        :scrollable="notifications.length"
        style="padding: 0 20px;"
      >
        <div v-if="!notifications.length">
          <v-row>
            <v-col
              cols="12"
              align="center"
            >
              <span class="messages">
                You have no new notifications yet.
              </span>
            </v-col>
          </v-row>
        </div>
        <div v-else>
          <v-row
            v-for="(notif, index) in sortedNotifications"
            :key="`notif.${index}`"
            :style="notificationBackground(notif)"
            class="notification-panels"
            @click="navigateToNotification(notif)"
          >
            <v-col
              cols="1"
              align="center"
              justify="center"
            >
              <v-icon
                v-if="!notif.seen"
                color="#0F8C15"
                size="20"
                class="details"
              >
                mdi-checkbox-blank-circle
              </v-icon>
            </v-col>
            <v-col cols="2">
              <v-img
                class="details"
                style="width: 48px;"
                :src="`${$metaData.app.userIcon}`"
              />
            </v-col>
            <v-col
              cols="6"
              class="messages"
            >
              <span>  {{ notif.message }} </span>
            </v-col>
            <v-col
              cols="3"
              align="right"
              class="dates"
            >
              <span> {{ getDate(notif.dateSent) }} </span>
            </v-col>
          </v-row>
          <v-spacer />
        </div>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'NotificationsList',
  props: {
    value: Boolean,
    notifications: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    sortedNotifications () {
      return this.$props.notifications.slice(0).reverse()
    }
  },
  created () {
    if (!this.$props.notifications.length) {
      this.fetchNotifications()
    }
  },
  methods: {
    // Sets the notification background
    notificationBackground (notification) {
      return !notification.seen ? 'background-color: #E5FFE7;' : '' // #E5FFE7
    },
    // emits the 'checkNotifications' function from NotificationsDialog.vue
    checkNotifications () {
      this.$emit('checkNotifications')
    },
    // returns formatted notification sent date
    getDate (dateSent) {
      const date = new Date(dateSent)
      const dateNow = new Date()
      if (date.getDate() === dateNow.getDate() && date.getMonth() === dateNow.getMonth() && date.getFullYear() === dateNow.getFullYear()) {
        return date.toLocaleTimeString('en-US')
      }
      return date.toLocaleDateString('en-US')
    },
    // emits the 'navigateToNotification' function from NotificationsDialog.vue
    navigateToNotification (notif) {
      this.$emit('navigateToNotification', notif)
    },
    // emits the 'fetchNotifications' function from NotificationsDialog.vue
    fetchNotifications () {
      this.$emit('fetchNotifications')
    }
  }
}

</script>

<style scoped>
  .message-class {
    padding: 20px;
  }
  .details {
    margin: 0;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .notification-panels {
    height: 180px;
    border-style: solid;
    border-width: 0 0 2px 0;
    border-color: #1D9F23;
    margin: 0 0 10pt 0;
  }
  .messages {
    font-size: 18px;
    font-weight: 700 !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .dates {
    font-size: 14px;
    font-weight: 500 !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
